module.exports = __webpack_public_path__ + "static/media/chess-maps logo.d7d225f9.png";